import styled from "styled-components";

import { ConsolePageButtonStyles } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";
import { ConsolePageSelectContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageSelect/styles";
import { ContentSectionRowContainer } from "@Console/components/molecules/ContentSection/molecules/atoms/Row/styles";
import { DataTableTemplateContainer } from "@Console/components/molecules/DataTable/templates/DataTableTemplate/styles";
import { AssignmentModalTaskCommentsContainer } from "@Console/tasks/components/molecules/AssignmentModalTaskComments/styles";

export const ConsoleTaskTemplateContainer = styled.section`
  max-width: 70.75rem;
  margin: 0 auto;
  padding: 0 1rem;

  margin-bottom: 5rem;

  * {
    transition: all 0.2s ease-in-out;
  }

  ${ConsolePageSelectContainer} {
    width: 250px;
  }

  ${DataTableTemplateContainer} {
    z-index: 1;
  }

  .icon-container {
    display: grid;
    place-items: center;
  }

  #admin-console-pesquisar-por-comentario-e-autor,
  > .icon-container > ${ConsolePageButtonStyles} {
    padding: 0;
    border: none;
  }

  > .loader {
    margin: 3rem auto;
    width: fit-content;
  }

  .data-grid-table-container {
    @media (max-width: 750px) {
      [data-field="status"] {
        display: none !important;
      }
    }

    @media (max-width: 650px) {
      [data-field="sent_in"] {
        display: none !important;
      }
    }

    @media (max-width: 500px) {
      [data-field="user"],
      [data-field="open_task"] {
        display: none !important;
      }
    }
  }

  .MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight) > .MuiDataGrid-cell {
    white-space: normal !important;
  }

  .MuiDataGrid-columnHeadersInner > [role="row"] {
    width: 100%;
  }

  ${ContentSectionRowContainer},
  ${AssignmentModalTaskCommentsContainer} {
    .row-texts .subtitle {
      color: ${({ theme }) => theme.console.pageSubtitleColor} !important;
    }

    .subtitle {
      color: ${({ theme }) => theme.console.pageSubtitleColor} !important;
    }
  }
`;
